import React, { useRef, useState } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import classNames from "classnames";
import styles from "./PinPluginsList.module.css";
import PropTypes from "prop-types";
import { PinPluginItem } from "../PinPluginItem/PinPluginItem";
import ViewPluginDetailsModal from "DreamStream/PluginsPage/Shared/ViewPluginDetailsModal";
import PluginDetailsItem from "DreamStream/PluginsPage/Shared/PluginDetailsItem";
import {
  getOriginalPinLevel,
  getNewPinLevel,
} from "DreamStream/PluginsPage/PinTab/utils/getPinLevel";

/**
 *
 * Scrollable list of pin plugins with a header.
 */

export function PinPluginsList({ plugins }) {
  const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref); // Now we pass the reference to the useDraggable hook:

  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [selectedPlugin, setSelectedPlugin] = useState(null);

  let originalPinText = "";
  let newPinText = "";

  if (selectedPlugin) {
    originalPinText = getOriginalPinLevel(selectedPlugin.originalPin);
    newPinText = getNewPinLevel(selectedPlugin.newPin);
  }

  const handleDetails = (data) => {
    setDetailsModalOpen(true);
    setSelectedPlugin(data);
  };

  return (
    <div className={styles.container}>
      <div className={classNames(styles.header)}>
        <div className={styles.item}>IBO</div>
        <div className={styles.item}>Name</div>
        <div className={classNames(styles.item, styles.itemPinText)}>
          Original Pin
        </div>
        <div className={classNames(styles.item, styles.itemNewPinText)}>
          New Pin
        </div>
      </div>
      <div className={classNames(styles.dragger)} {...events} ref={ref}>
        {plugins.map((item, index) => (
          <div
            className={classNames(
              styles.whiteBG,
              index % 2 == 1 && styles.slightlyDarkerBackground
            )}
          >
            <PinPluginItem
              pluginInfo={item}
              onClick={() => handleDetails(item)}
            />
          </div>
        ))}
      </div>

      <ViewPluginDetailsModal
        title="VIEW ADD PIN PLUGIN DETAILS"
        isOpen={detailsModalOpen}
        errors={[]}
        onClose={() => setDetailsModalOpen(false)}
        onDelete={() => alert("onDelete clicked.")}
        children={
          <>
            {selectedPlugin && (
              <div className={styles["modal-container"]}>
                <div className={styles["detail-container"]}>
                  <div className={styles["label-column"]}>Plugin ID:</div>
                  <div className={styles["detail-column"]}>
                    {selectedPlugin.id}
                  </div>
                </div>
                <div className={styles["detail-container"]}>
                  <div className={styles["label-column"]}>
                    The Pin Level For
                  </div>
                  <div className={styles["detail-column"]}>
                    <PluginDetailsItem
                      // src="https://wwguscms.blob.core.windows.net/images/cms/thumbnail/793844d0-334a-11ec-882f-dfd435b7f374/EwiHH-fWUAUavjX.jpeg"
                      name={selectedPlugin.name}
                      isGroup={false}
                      id={selectedPlugin.iboNumber}
                    />
                  </div>
                </div>

                <div className={styles.set}>
                  <p>
                    Has been manually set to
                    <span className={styles.bold}>{newPinText}</span>
                    for syncing purposes.
                  </p>
                </div>
                <div
                  className={classNames(
                    styles["detail-container"],
                    styles["detail-admin"]
                  )}
                >
                  <div className={styles["label-column"]}>Original Pin</div>
                  <div className={styles["detail-column"]}>
                    {`${originalPinText} (${selectedPlugin.originalPin})`}
                  </div>
                </div>
                {/* <div className={styles["detail-container"]}>
                  <div className={styles["label-column"]}>Date Created</div>
                  <div className={styles["detail-column"]}>
                    {`${selectedPlugin.date} ${selectedPlugin.time}`}
                  </div>
                </div> */}
              </div>
            )}
          </>
        }
      />
    </div>
  );
}

PinPluginsList.propTypes = {
  /**
   * Array of plugin objects.
   */
  plugins: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      originalPin: PropTypes.number,
      newPin: PropTypes.number,
      date: PropTypes.string,
      time: PropTypes.string,
    })
  ),
};
